// extracted by mini-css-extract-plugin
export default {"formGroup":"FormGroup_formGroup__e1gkF","column":"FormGroup_column__gydMc"};